import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import { useGlobal } from '@/utils/useGlobal';

export default function SectionB() {
    const { useLang } = useGlobal();
    const { t } = useLang('ces2023');
    useEffect(() => {
        const controller = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.sectionB',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '70%',
        });

        const tweenA1 = TweenMax.fromTo(
            '.sectionB .textContainer',
            0.5,
            {
                opacity: 0,
                ease: 'ease-out',
            },
            {
                opacity: 1,
                ease: 'ease-out',
            },
        );

        sceneA1.setTween(tweenA1);
        controller.addScene(sceneA1);
    }, []);
    return (
        <div className="sectionB sectionStyle">
            <div className="textContainer">
                <div className="textItem">
                    <p className="title">{t('sectionB.title1')}</p>
                    <p className="content">{t('sectionB.desc1')}</p>
                </div>
                <div className="textItem yellow">
                    <p className="title">{t('sectionB.title2')}</p>
                    <p className="content">{t('sectionB.desc2')}</p>
                </div>
                <div className="shadowText">
                    <div className="line"></div>
                    <div>{t('sectionB.desc3')}</div>
                </div>
            </div>
        </div>
    );
}
